import { PlaceholderButton } from '@/shared/components/actions/placeholder-button';
import { CustomTable } from '@/shared/components/table/table';
import { CustomTableHeader } from '@/shared/components/table/table-header';
import { TableBody } from '@/shared/components/ui/table';
import { cn } from '@/shared/utils/cn';

export const EmptyTablePlaceholder = ({
  title,
  description,
  columns,
  action,
  centered = false,
  withHeader = true,
  dottedBorder = false,
}: {
  title: string;
  description?: string;
  columns: string[];
  action?: () => void;
  centered?: boolean;
  withHeader?: boolean;
  dottedBorder?: boolean;
}) => {
  return (
    <CustomTable dottedBorder={dottedBorder}>
      {withHeader && (
        <CustomTableHeader columns={columns} withContainer={false} />
      )}
      <TableBody>
        <EmptyTablePlaceholderContent
          title={title}
          description={description}
          action={action}
          centered={centered}
        />
      </TableBody>
    </CustomTable>
  );
};

export const EmptyTablePlaceholderContent = ({
  className,
  title,
  description,
  action,
  centered = false,
}: {
  className?: string;
  title: string;
  description?: string;
  action?: () => void;
  centered?: boolean;
}) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-6 p-[42px]',
        centered ? 'flex-col' : 'flex-row',
        className,
      )}
    >
      <div className={cn('flex flex-col gap-2', centered && 'text-center')}>
        <div className="text-xs font-semibold text-white">{title}</div>
        {description && (
          <div className="text-2xs text-white">
            <span className="whitespace-pre-line">{description}</span>
          </div>
        )}
      </div>
      {action && <PlaceholderButton action={action} />}
    </div>
  );
};
